export const LocalStorageNames = {
  accessToken: 'access_token',
  user: 'user'
};
